import { Checkbox, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import { getPriorityItemColour } from '../../utils/Utils';

interface ITimelineLegendsProps {
  setFilters: (updatedFilters: string[]) => void;
  priorityStates: string[];
}

function TimelineLegend(props: ITimelineLegendsProps) {
  const { setFilters, priorityStates } = props;
  const [checked, setChecked] = useState<string[]>(priorityStates);

  function getLegendItems() {
    return priorityStates.map(status => generateLegendItem(status, getPriorityItemColour(status)));
  }

  function handleToggle(value: string) {
    const index = checked.indexOf(value);
    const updatedChecked = [...checked];

    if (index === -1) {
      updatedChecked.push(value);
    } else {
      updatedChecked.splice(index, 1);
    }

    setChecked(updatedChecked);
    setFilters(updatedChecked);
  }

  const generateLegendItem = (status: string, statusColour: string) => {
    return (
      <Stack direction="row" alignItems={'center'} key={status}>
        <Checkbox
          size="small"
          checked={checked.includes(status)}
          onChange={() => handleToggle(status)}
          name={status}
          sx={{
            color: statusColour,
            '&.Mui-checked': {
              color: statusColour,
            },
          }}
        />
        <Typography fontWeight={'bold'} sx={{ color: statusColour }}>
          {status}
        </Typography>
      </Stack>
    );
  };

  return (
    <Stack sx={{ background: '#F0F0F0', padding: 0.5, borderRadius: 2 }}>
      <Typography variant="subtitle2" textAlign="center" color="#202020">
        Priority Status
      </Typography>
      <Stack direction="row" spacing={2}>
        {getLegendItems()}
      </Stack>
    </Stack>
  );
}

export default TimelineLegend;
